interface buttonItem {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    isSelected?: boolean;
    className?: string;
}

interface GroupButtonProps {
    className?: string;
    buttons?: buttonItem[];
}

const baseButtonStyle =
    'outline outline-1 outline-offset-[-1px] justify-center border-teal-50 flex-1 relative inline-flex items-center px-3 py-2 text-sm font-semibold hover:cursor-pointer focus:z-10';

const firstButtonStyle = `${baseButtonStyle} rounded-l-md`;
const middleButtonStyle = `${baseButtonStyle}`;
const lastButtonStyle = `${baseButtonStyle} rounded-r-md`;

const GroupButtons = ({ className, buttons }: GroupButtonProps) => {
    const renderButtons = buttons?.map((button, index) => {
        let buttonStyle = middleButtonStyle;
        if (buttons.length > 1) {
            if (index === 0) {
                buttonStyle = firstButtonStyle;
            } else if (index === buttons.length - 1) {
                buttonStyle = lastButtonStyle;
            }
        }

        return (
            <button
                key={`button_${index}`}
                type="button"
                className={`${buttonStyle} ${button.isSelected ? 'bg-teal-600 text-white hover:bg-teal-500 hover:text-white' : 'bg-white text-neutral-800 outline-neutral-300 hover:bg-zinc-950/[2.5%] hover:text-neutral-800'} ${button.className || ''}`}
                onClick={button.onClick}
                disabled={button.disabled}
            >
                {button.label}
            </button>
        );
    });

    return (
        <div className={`inline-flex h-11 items-center justify-center overflow-hidden rounded-md ${className || ''}`}>
            {renderButtons}
        </div>
    );
};

export default GroupButtons;
